module.exports = __webpack_public_path__ + "img/10.89d80993.png";